/* eslint-disable */
export default {
  despesas: [],
  colunasCabecalho: [
    { "value": "referenciaInterna", "text": "Referência Trust", "data_type": "VARCHAR" },
    { "value": "referenciaCliente", "text": "Referência do Cliente", "data_type": "VARCHAR" },
    { "value": "exportador", "text": "Exportador", "data_type": "VARCHAR" },
    { "value": "produto", "text": "Produto", "data_type": "VARCHAR" },
    { "value": "quantidade", "text": "Quantidade", "data_type": "VARCHAR" },
    { "value": "unidade_medida", "text": "Unidade de Medida", "data_type": "VARCHAR" },
    { "value": "pesoLiquido", "text": "Peso Líquido", "data_type": "DECIMAL" },
    { "value": "pesoBruto", "text": "Peso Bruto", "data_type": "DECIMAL" },
    { "value": "canal", "text": "Canal", "data_type": "VARCHAR" },
    { "value": "dataAbertura", "text": "Data de Abertura", "data_type": "DATE" },
    { "value": "fechamentoOperacional", "text": "Fechamento Operacional", "data_type": "DATE" },
    { "value": "carregamento", "text": "Data de Carregamento", "data_type": "DATE" },
    { "value": "solicitacaoCarregamento", "text": "Solicitação de Carregamento", "data_type": "DATE" },
    { "value": "fechamentoFinanceiro", "text": "Fechamento Financeiro", "data_type": "DATE" },
    { "value": "envioFaturamento", "text": "Envio para Faturamento", "data_type": "DATE" },
    { "value": "embarque", "text": "Data de Embarque", "data_type": "DATE" },
    { "value": "chegada", "text": "Data de Chegada", "data_type": "DATE" },
    { "value": "previsaoChegada", "text": "Previsão de Chegada", "data_type": "DATE" },
    { "value": "previsaoEmbarque", "text": "Previsão de Embarque", "data_type": "DATE" },
    { "value": "liberacaoMapa", "text": "Liberação de Mapa", "data_type": "DATE" },
    { "value": "liberacaoSiscarga", "text": "Liberação Siscarga", "data_type": "DATE" },
    { "value": "presencaCarga", "text": "Presença de Carga", "data_type": "DATE" },
    { "value": "conhecimentoEmbarque", "text": "Conhecimento de Embarque", "data_type": "VARCHAR" },
    { "value": "vistoriaMapa", "text": "Data de Vistoria do Mapa", "data_type": "DATE" },
    { "value": "recebimentoOriginais", "text": "Data de Recebimento dos Originais", "data_type": "DATE" },
    { "value": "frete_nacional", "text": "Frete Nacional", "data_type": "DECIMAL" },
    { "value": "ipi", "text": "IPI", "data_type": "DECIMAL" },
    { "value": "pis", "text": "PIS", "data_type": "DECIMAL" },
    { "value": "cofins", "text": "COFINS", "data_type": "DECIMAL" },
    { "value": "frete_internacional", "text": "Frete Internacional", "data_type": "DECIMAL" },
    { "value": "seguro_internacional", "text": "Seguro Internacional", "data_type": "DECIMAL" },
    { "value": "II", "text": "II", "data_type": "DECIMAL" },
    { "value": "siscomex", "text": "Siscomex", "data_type": "DECIMAL" },
    { "value": "valor_liquido", "text": "Valor Líquido", "data_type": "DECIMAL" },
    { "value": "desconto_encomenda", "text": "Desconto de Encomenda", "data_type": "DECIMAL" },
    { "value": "serie", "text": "Série", "data_type": "VARCHAR" },
    { "value": "valorNFE", "text": "Valor NFE", "data_type": "VARCHAR" },
  ],
  filtros: [],
};
